module.exports = __webpack_public_path__ + "img/clock.ed8d8690.svg";